import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateTechnology, privateTechnologiesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const PRIVATE_TECHNOLOGY_MODULE = 'privateTechnology';

const dataObjectModule = getDataObjectsModule<IPrivateTechnology>(privateTechnologiesManager, 5);
const searchModule = getSearchModule();

const privateTechnologyModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_TECHNOLOGY_MODULE, privateTechnologyModuleInstance);

export { PRIVATE_TECHNOLOGY_MODULE };
